import { LOW_BATTERY_THRESHOLD } from './constants/lowBatteryThreshold';

/**
 * Determine which battery-level zone a device (Hub or individual sensor) falls into,
 * for the purpose of selecting the appropriate battery icon/color in the UI:
 *   - 'low'    → red icon
 *   - 'medium' → orange icon
 *   - 'high'   → green icon
 *
 * Action required based on battery zone:
 *   - 'low'    → Charge the device, charging required to continue
 *   - 'medium' → Charge the device soon, but you can continue using it
 *   - 'high'   → No immediate action required
 *
 * Assumptions & Edge Cases:
 * - `batteryLevel` is expected to be a percentage in the range 0–100.
 *
 * @param batteryLevel
 *   The current battery level as a percentage (0–100). If `undefined`,
 *   the function conservatively returns 'low'.
 * @returns
 *   A string literal indicating the battery zone:
 *   - `'low'`    for levels ≤ 20 or undefined
 *   - `'medium'` for levels ≤ 50
 *   - `'high'`   for levels > 50
 */
export function getBatteryZone(batteryLevel: number | undefined): 'low' | 'high' | 'medium' {
  if (batteryLevel === undefined || batteryLevel <= LOW_BATTERY_THRESHOLD) {
    return 'low';
  }

  if (batteryLevel <= 50) {
    return 'medium';
  }

  return 'high';
}
